import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getQuoteData,
  getSinglePackage,
  createQuote,
} from "../../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import Select from "react-select";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
const StepThree = ({
  formData,
  handleChange,
  nextStep,
  prevStep,
  currentStep,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let QuoteId = sessionStorage.getItem("quote_id");

  if (location.state != undefined && location.state != null &&  location.state.record_id == undefined) {
    sessionStorage.setItem("quote_id", location.state.row.id);
    QuoteId = location.state.row.id;
  }

  const [quoteData, setQuoteData] = useState({});
  const [selectedPackage, setSelectedPackage] = useState("");
  const [comparePackage, setComparePackage] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [AllPackagesServices, setAllPackagesServices] = useState([]);
  const [quotePackageServices, setQuotePackageServices] = useState([]);
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));

  let paymentMethodsArray = [];
  const agent_payment_settings = JSON.parse(
    localStorage.getItem("agent_payment_settings")
  );
  if (
    agent_payment_settings != null &&
    agent_payment_settings != undefined &&
    typeof agent_payment_settings == "object"
  ) {
    paymentMethodsArray = Object.values(agent_payment_settings);
  }

  const [includeInQuote, setIncludeInQuote] = useState({
    include: { value1: false, value2: false, value3: false },
    p_id: { value1: "", value2: "", value3: "" },
    discount: { value1: "", value2: "", value3: "" },
    premium: { value1: "", value2: 0, value3: 0 },
    yearlyCost: { value1: "", value2: "", value3: "" },
    netVat: { value1: "", value2: "", value3: "" },
    netNoVat: { value1: "", value2: "", value3: "" },
    vat: { value1: "", value2: "", value3: "" },
    withoutDiscountValue: { value1: "", value2: "", value3: "" },
    totalIncludingVat: { value1: "", value2: "", value3: "" },
    payment_term_ongoing: { value1: "", value2: "", value3: "" },
    total_monthly_ongoing: { value1: "", value2: "", value3: "" },
    payment_type_ongoing: { value1: "", value2: "", value3: "" },
    payment_frequency_ongoing: { value1: "", value2: "", value3: "" },
    threshold_discount_ongoing: { value1: "", value2: "", value3: "" },
    admin_charge_ongoing: { value1: "", value2: "", value3: "" },
  });

  useEffect(() => {
    getQuote();
  }, []);

  const getQuote = async () => {
    const req = {
      id: Number(QuoteId),
      agent_id: agent_id,
      ongoing_onoff: ["0", "1"],
    };
    await dispatch(getQuoteData(req))
      .unwrap()
      .then(async (res) => {
        if (res.status) {
          setQuoteData({
            quote: res.quote,
            services: res.services,
            packages: res.packages,
          });
          const filteredPackageWithRecurringService =
            res.quote.QuotePackageServices.filter(
              (item) =>
                item.package_id != null || Number(item.service_type) === 1
            );
          setFilteredPackages(filteredPackageWithRecurringService);

          const filteredPackage = res.quote.QuotePackageServices.filter(
            (item) => item.package_id != null
          );
          setSelectedPackage(filteredPackage?.[0]?.package_id);
          setIncludeInQuote({
            include: { value1: true, value2: false, value3: false },
            p_id: {
              value1: filteredPackage?.[0]?.package_id,
              value2: "",
              value3: "",
            },

            discount: {
              value1:
                Number(res.quote.status_discount_ongoing) == 2
                  ? res.quote.threshold_discount_ongoing
                  : res.quote.discount_ongoing,
              value2: "",
              value3: "",
            },

            premium: {
              value1: res?.quote?.premium_ongoing,
              value2: "",
              value3: "",
            },

            yearlyCost: {
              value1: res?.quote?.yearly_cost,
              value2: "",
              value3: "",
            },

            netVat: {
              value1: res?.quote?.net20vat_ongoing,
              value2: "",
              value3: "",
            },

            netNoVat: {
              value1: res?.quote?.netnovat_ongoing,
              value2: "",
              value3: "",
            },

            vat: { value1: res?.quote?.vat_ongoing, value2: "", value3: "" },

            totalIncludingVat: {
              value1: res?.quote?.total_including_ongoing,
              value2: "",
              value3: "",
            },

            payment_term_ongoing: {
              value1: res?.quote?.payment_term_ongoing,
              value2: "",
              value3: "",
            },

            total_monthly_ongoing: {
              value1: res?.quote?.total_monthly_ongoing.toFixed(2),
              value2: "",
              value3: "",
            },

            payment_type_ongoing: {
              value1: res?.quote?.payment_type_ongoing,
              value2: "",
              value3: "",
            },

            payment_frequency_ongoing: {
              value1: res?.quote?.payment_frequency_ongoing,
              value2: "",
              value3: "",
            },

            threshold_discount_ongoing: {
              value1: res?.quote?.threshold_discount_ongoing,
              value2: "",
              value3: "",
            },

            admin_charge_ongoing: {
              value1: res?.quote?.admin_charge_ongoing,
              value2: "",
              value3: "",
            },
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getServiceByPackageId = async (selectedOption, selectedOption_one) => {
    if (!selectedOption) {
      return;
    }
    const req = { package_id: selectedOption.value, agent_id: agent_id };
    await dispatch(getSinglePackage(req))
      .unwrap()
      .then(async (res) => {
        if (res.status) {
          const PAKAGE1 =
            selectedOption_one.length == 1 ? selectedOption_one[0]?.value : "";
          const PAKAGE2 =
            selectedOption_one.length == 2 ? selectedOption_one[1]?.value : "";

          let paymentFrequencyValue;

          let paymentDivisorsOngoing = {
            monthly_dd: 12,
            quarterly_dd: 4,
            "100_upfront": 1,
            "50_upfront": 2,
            "100_post_completion": 1,
            manual_payment_monthly: 12,
            manual_payment_quarterly: 4,
          };

          if (PAKAGE1 !== "") {
            const transformedData = res?.services.map((service) => ({
              package_id: service.package_id,
              service_id: service.Service.id,
              price: service.price,
              vat: service.Service.vat,
              chargetypes: service.PackageServiceRules.map((rule) => {
                const matchingChargeBasisValue =
                  service.Service.ServiceChargeBases.flatMap(
                    (base) => base.ServiceChargeBasisValues
                  ).find(
                    (value) =>
                      value.chargetype_rule_id === rule.chargetype_rule_id
                  );

                return matchingChargeBasisValue
                  ? {
                    id: matchingChargeBasisValue.ChargeType.id,
                    value:
                      parseFloat(matchingChargeBasisValue.value) *
                      parseFloat(rule.inputValue || 1),
                    valueExist: parseFloat(matchingChargeBasisValue.value),
                    operator: service.Service.ServiceChargeBases.find(
                      (base) =>
                        base.ServiceChargeBasisValues.includes(
                          matchingChargeBasisValue
                        )
                    ).operator,
                    inputValue: rule.inputValue,
                  }
                  : null;
              }).filter(Boolean),
            }));

            setQuotePackageServices((prev) => {
              // Check if the package_id already exists in the state
              const exists = prev.some((item) => item.package_id === PAKAGE1);
              if (exists) {
                return prev;
              }
              return [
                ...prev,
                { package_id: PAKAGE1, service: transformedData },
              ];
            });

            const Package = quoteData.packages.find(
              (item) => item.id == PAKAGE1
            );

            let yearly_cost = yearlyCostPackageservices(
              PAKAGE1,
              res.services,
              Package?.default_discount
            );
            let net_20_vat = yearlyNet20vat(
              PAKAGE1,
              res.services,
              Package?.default_discount,
              1
            );
            let vat = yearlyNet20vat(
              PAKAGE1,
              res.services,
              Package?.default_discount,
              2
            );
            let net_no_vat = yearlyNet20vat(
              PAKAGE1,
              res.services,
              Package?.default_discount,
              3
            );

           
            
            let totalIncludingVATOngoing =
              +parseFloat(net_20_vat) +
              parseFloat(net_no_vat) +
              parseFloat(vat);

            let totalMonthlyCostOngoing =
              totalIncludingVATOngoing /
              (paymentDivisorsOngoing[
                includeInQuote.payment_term_ongoing.value1
              ] || 1);

            let adminChargeOngoing = 0;
            // Apply extra admin charge for manual payments
            if (
              includeInQuote.payment_term_ongoing.value1 ===
              "manual_payment_monthly"
            ) {
              adminChargeOngoing = Math.max(
                (totalIncludingVATOngoing * 5) / 100,
                25
              );
              totalMonthlyCostOngoing += adminChargeOngoing;
            } else if (
              includeInQuote.payment_term_ongoing.value1 ===
              "manual_payment_quarterly"
            ) {
              adminChargeOngoing = Math.max(
                (totalIncludingVATOngoing * 5) / 100,
                50
              );
              totalMonthlyCostOngoing += adminChargeOngoing;
            }

            setIncludeInQuote((prev) => ({
              ...prev,
              discount: { ...prev.discount, value2: Package?.default_discount },
              p_id: { ...prev.p_id, value2: PAKAGE1 },
              yearlyCost: { ...prev.yearlyCost, value2: yearly_cost },
              netVat: { ...prev.netVat, value2: vat },
              vat: { ...prev.vat, value2: net_20_vat },
              netNoVat: { ...prev.netNoVat, value2: net_no_vat },
              threshold_discount_ongoing: {
                ...prev.threshold_discount_ongoing,
                value2: Package?.threshold_discount,
              },
              totalIncludingVat: {
                ...prev.totalIncludingVat,
                value2: (
                  +parseFloat(net_20_vat) +
                  parseFloat(net_no_vat) +
                  parseFloat(vat)
                ).toFixed(2),
              },
              total_monthly_ongoing: {
                ...prev.total_monthly_ongoing,
                value2: totalMonthlyCostOngoing.toFixed(2),
                value3: "",
              },
              admin_charge_ongoing: {
                ...prev.admin_charge_ongoing,
                value2: adminChargeOngoing.toFixed(2),
                value3: "",
              }
            }));
          }

          if (PAKAGE2 !== "") {
            const transformedData = res?.services.map((service) => ({
              package_id: service.package_id,
              service_id: service.Service.id,
              price: service.price,
              vat: service.Service.vat,
              chargetypes: service.PackageServiceRules.map((rule) => {
                const matchingChargeBasisValue =
                  service.Service.ServiceChargeBases.flatMap(
                    (base) => base.ServiceChargeBasisValues
                  ).find(
                    (value) =>
                      value.chargetype_rule_id === rule.chargetype_rule_id
                  );

                return matchingChargeBasisValue
                  ? {
                    id: matchingChargeBasisValue.ChargeType.id,
                    value:
                      parseFloat(matchingChargeBasisValue.value) *
                      parseFloat(rule.inputValue || 1),
                    valueExist: parseFloat(matchingChargeBasisValue.value),
                    operator: service.Service.ServiceChargeBases.find(
                      (base) =>
                        base.ServiceChargeBasisValues.includes(
                          matchingChargeBasisValue
                        )
                    ).operator,
                    inputValue: rule.inputValue,
                  }
                  : null;
              }).filter(Boolean),
            }));

            setQuotePackageServices((prev) => {
              const exists = prev.some((item) => item.package_id === PAKAGE2);
              if (exists) {
                return prev;
              }
              return [
                ...prev,
                { package_id: PAKAGE2, service: transformedData },
              ];
            });

            const Package = quoteData.packages.find(
              (item) => item.id == PAKAGE2
            );
            let yearly_cost = yearlyCostPackageservices(
              PAKAGE2,
              res.services,
              Package?.default_discount
            );
            let net_20_vat = yearlyNet20vat(
              PAKAGE2,
              res.services,
              Package?.default_discount,
              1
            );
            let vat = yearlyNet20vat(
              PAKAGE2,
              res.services,
              Package?.default_discount,
              2
            );
            let net_no_vat = yearlyNet20vat(
              PAKAGE2,
              res.services,
              Package?.default_discount,
              3
            );


            let totalIncludingVATOngoing =
            +parseFloat(net_20_vat) +
            parseFloat(net_no_vat) +
            parseFloat(vat);

          let totalMonthlyCostOngoing =
            totalIncludingVATOngoing /
            (paymentDivisorsOngoing[
              includeInQuote.payment_term_ongoing.value1
            ] || 1);

          let adminChargeOngoing = 0;
          // Apply extra admin charge for manual payments
          if (
            includeInQuote.payment_term_ongoing.value1 ===
            "manual_payment_monthly"
          ) {
            adminChargeOngoing = Math.max(
              (totalIncludingVATOngoing * 5) / 100,
              25
            );
            totalMonthlyCostOngoing += adminChargeOngoing;
          } else if (
            includeInQuote.payment_term_ongoing.value1 ===
            "manual_payment_quarterly"
          ) {
            adminChargeOngoing = Math.max(
              (totalIncludingVATOngoing * 5) / 100,
              50
            );
            totalMonthlyCostOngoing += adminChargeOngoing;
          }



            setIncludeInQuote((prev) => ({
              ...prev,
              discount: { ...prev.discount, value3: Package?.default_discount },
              p_id: { ...prev.p_id, value3: PAKAGE2 },
              yearlyCost: { ...prev.yearlyCost, value3: yearly_cost },
              netVat: { ...prev.netVat, value3: vat },
              vat: { ...prev.vat, value3: net_20_vat },
              netNoVat: { ...prev.netNoVat, value3: net_no_vat },
              threshold_discount_ongoing: {
                ...prev.threshold_discount_ongoing,
                value3: Package?.threshold_discount,
              },
              totalIncludingVat: {
                ...prev.totalIncludingVat,
                value3: (
                  parseFloat(net_20_vat) +
                  parseFloat(net_no_vat) +
                  parseFloat(vat)
                ).toFixed(2),
              },

              total_monthly_ongoing: {
                ...prev.total_monthly_ongoing,
                value3: totalMonthlyCostOngoing.toFixed(2),
              },
              admin_charge_ongoing: {
                ...prev.admin_charge_ongoing,
                value3: adminChargeOngoing.toFixed(2),
              }



            }));
          }

          if (AllPackagesServices.length > 0) {
            setAllPackagesServices((prevServices) => {
              const newServices = res.services.filter(
                (newService) =>
                  !prevServices.some(
                    (prevService) => prevService.id === newService.id
                  )
              );
              return [...prevServices, ...newServices];
            });
          } else {
            setAllPackagesServices(res.services);
          }
        } else {
          setAllPackagesServices([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const yearlyCostPackageservices = (package_id, services, discount) => {
    let servicesData = services.filter(
      (service) => service.package_id == package_id
    );
    let total = 0;
    servicesData?.map((service) => {
      total += service.price;
    });
    total = total - (total * discount) / 100;
    return total.toFixed(2);
  };

  const yearlyNet20vat = (package_id, services, discount, type) => {
    if (type == 1) {
      let servicesData = services.filter(
        (service) =>
          service.package_id == package_id && service.Service.vat == "1"
      );

      let total = 0;
      servicesData?.map((service) => {
        total += service.price;
      });
      total = total - (total * discount) / 100;
      total = (total * 20) / 100;
      return total.toFixed(2);
    } else if (type == 2) {
      let servicesData = services.filter(
        (service) =>
          service.package_id == package_id && service.Service.vat == "1"
      );
      let total = 0;
      servicesData?.map((service) => {
        total += service.price;
      });
      total = total - (total * discount) / 100;
      return total.toFixed(2);
    } else if (type == 3) {
      let servicesData = services.filter(
        (service) =>
          service.package_id == package_id && service.Service.vat == "0"
      );
      let total = 0;
      servicesData?.map((service) => {
        total += service.price;
      });
      total = total - (total * discount) / 100;
      return total.toFixed(2);
    } else {
      return 0;
    }
  };

  const handlePackageChange = (selectedOption) => {
    if (selectedOption.length > 2) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "You can only compare two packages",
        timer: 3000,
        timerProgressBar: true,
      });
      return;
    }

    const filteredServices = AllPackagesServices?.filter((service) =>
      selectedOption?.some((data) => data?.value == service?.package_id)
    );

    setAllPackagesServices(filteredServices);
    setComparePackage(selectedOption);
    getServiceByPackageId(
      selectedOption[selectedOption.length - 1],
      selectedOption
    );
  };

  const combineServices = (filteredPackages, AllPackagesServices) => {
    const allServiceIds = new Set([
      ...filteredPackages.map((service) => service.Service.id),
      ...AllPackagesServices.map((service) => service.Service.id),
    ]);

    const packageIds = Array.from(
      new Set(AllPackagesServices.map((service) => service.package_id))
    );
    const firstPackageId = packageIds[0];
    const secondPackageId = packageIds[1];

    return Array.from(allServiceIds).map((service_id) => {
      const matchedFiltered = filteredPackages.find(
        (pkg) => pkg.Service.id == service_id
      );
      const matchedAll = AllPackagesServices.filter(
        (pkg) => pkg.Service.id === service_id
      );

      // Aggregate price for all matches
      const aggregatedPrice = matchedAll.reduce(
        (sum, pkg) => sum + (pkg.price || 0),
        0
      );
      const firstPackageMatch = matchedAll.find(
        (pkg) => pkg.package_id === firstPackageId
      );
      const secondPackageMatch = matchedAll.find(
        (pkg) => pkg.package_id === secondPackageId
      );

      return {
        service_id,
        price: matchedFiltered ? matchedFiltered.price : "*",
        price2:
          firstPackageId && firstPackageMatch ? firstPackageMatch.price : "*",
        price3:
          secondPackageId && secondPackageMatch
            ? secondPackageMatch.price
            : "*",
        aggregatedPrice, // New aggregated price from all matches
        available: !!matchedFiltered,
        name: matchedFiltered?.Service?.name || matchedAll[0]?.Service?.name,
        ServiceType:
          matchedFiltered?.Service?.ServiceType?.name ||
          matchedAll[0]?.Service?.ServiceType?.name,
      };
    });
  };

  const MyTableComponent = ({ filteredPackages, AllPackagesServices }) => {
    const combinedServices = combineServices(
      filteredPackages,
      AllPackagesServices
    );

    const getPackageName = (filteredPackages) => {
      if (filteredPackages.length > 0) {
        const filterName = quoteData?.packages?.filter(
          (item) => item.id == filteredPackages[0]?.package_id
        );
        return filterName[0]?.name;
      }
    };

    return (
      <table className="table table-custom">
        <thead>
          <tr>
            <th>Service</th>
            <th>Type</th>
            <th>{getPackageName(filteredPackages)}</th>
            {comparePackage.length >= 1 && <th>{comparePackage[0]?.label}</th>}
            {comparePackage.length >= 2 && <th>{comparePackage[1]?.label}</th>}
          </tr>
        </thead>
        <tbody>
          {combinedServices.map((service) => (
            <tr key={service.service_id}>
              <td>{service.name}</td>
              <td>{service.ServiceType}</td>
              <td className="" style={{ color: "#ff00aa" }}>
                {service.price !== "*" ? (
                  `£ ${service.price}`
                ) : (
                  <i className="text-dark bx bx-x-circle"></i>
                )}
              </td>
              {comparePackage.length >= 1 && (
                <td style={{ color: "#ff00aa" }}>
                  {service.price2 !== "*" ? (
                    `£ ${service.price2}`
                  ) : (
                    <i className="text-dark bx bx-x-circle"></i>
                  )}
                </td>
              )}
              {comparePackage.length >= 2 && (
                <td style={{ color: "#ff00aa" }}>
                  {service.price3 !== "*" ? (
                    `£ ${service.price3}`
                  ) : (
                    <i className="text-dark bx bx-x-circle"></i>
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const handleSubmit = async () => {
    let data = {
      discount: includeInQuote.discount.value1 || 0,
      premium: includeInQuote.premium.value1 || 0,
      yearly_cost: includeInQuote.yearlyCost.value1,
      net_20_vat: includeInQuote.netVat.value1,
      net_no_vat: includeInQuote.netNoVat.value1,
      vat: includeInQuote.vat.value1,
      total_including_vat: includeInQuote.totalIncludingVat.value1,
    };


    
    // Payment Type
    const paymentDivisorsTypeOngoing = {
      monthly_dd: 'payment',
      quarterly_dd: 'payment',
      '100_upfront': 'stripe',
      '50_upfront': 'stripe',
      '100_post_completion': 'stripe',
      manual_payment_monthly: "manual_payment",
      manual_payment_quarterly: 'manual_payment',
    };
    let payment_type_ongoing = (paymentDivisorsTypeOngoing[includeInQuote.payment_term_ongoing.value1])


      // Payment Frequency
      const paymentDivisorsFreguencyOngoing = {
        monthly_dd: 'monthly',
        quarterly_dd: 'quarterly',
        '100_upfront': 'yearly',
        '50_upfront': 'halfyearly',
        '100_post_completion': 'yearly',
        manual_payment_monthly: "monthly",
        manual_payment_quarterly: 'quarterly',
      };
      let payment_frequency_ongoing = (paymentDivisorsFreguencyOngoing[includeInQuote.payment_term_ongoing.value1])




    let finalquotepackageservices = [];
    let packageID = includeInQuote.p_id.value1;

    if (includeInQuote.include.value2 == true) {
      let finalquotepackageservices2 = quotePackageServices?.find(
        (item) => item.package_id == includeInQuote.p_id.value2
      )?.service;

      finalquotepackageservices =
        finalquotepackageservices2 &&
        finalquotepackageservices2.map((service) => {
          const basePrice = service.price || 0;
          const OngoingDicountApply = includeInQuote.discount.value2;
          const basePriceWithDiscount =
            basePrice - basePrice * ((OngoingDicountApply || 0) / 100);

          let vat_applied = "0";
          let price_aftervat = "0";
          if (service.vat === "1") {
            vat_applied = "20";
            price_aftervat =
              basePriceWithDiscount + (basePriceWithDiscount * 20) / 100;
          }

          let price_afterpremimum =
            basePriceWithDiscount +
            basePriceWithDiscount *
            ((includeInQuote.premium.value2 || 0) / 100);

          return {
            ...service,
            mode: "ongoing",
            package_flag: "1",
            premium_applied: includeInQuote.premium.value2 || 0,
            price_afterpremimum: price_afterpremimum || 0,
            discount_rate: OngoingDicountApply,
            price_afterdiscount: basePriceWithDiscount,
            status_discount: "1",
            vat_applied: vat_applied || 0,
            price_aftervat: price_aftervat || 0,
            service_type: "1",
          };
        });

      packageID = includeInQuote.p_id.value2;
      data = {
        // discount: includeInQuote.discount.value2 || 0,
        // premium: includeInQuote.premium.value2 || 0,
        // yearly_cost: includeInQuote.yearlyCost.value2,
        // net_20_vat: includeInQuote.netVat.value2,
        // net_no_vat: includeInQuote.netNoVat.value2,
        // vat: includeInQuote.vat.value2,
        // total_including_vat: includeInQuote.totalIncludingVat.value2

        // Ongoing Services
        discount_ongoing: includeInQuote.discount.value2 || 0,
        premium_ongoing: includeInQuote.premium.value2 || 0,
        threshold_discount_ongoing:
          includeInQuote.threshold_discount_ongoing.value2 || 0,
        status_discount_ongoing: "1",
        payment_term_ongoing: includeInQuote.payment_term_ongoing.value1,
        total_including_ongoing: includeInQuote.totalIncludingVat.value2,
        total_monthly_ongoing:includeInQuote.total_monthly_ongoing.value2,
        payment_type_ongoing: payment_type_ongoing,
        payment_frequency_ongoing: payment_frequency_ongoing,
        net20vat_ongoing: includeInQuote.netVat.value2 || 0,
        vat_ongoing: includeInQuote.vat.value2 || 0,
        netnovat_ongoing: includeInQuote.netNoVat.value2 || 0,
      };
    } else if (includeInQuote.include.value3 == true) {
      let finalquotepackageservices3 = quotePackageServices?.find(
        (item) => item.package_id == includeInQuote.p_id.value3
      )?.service;

      finalquotepackageservices =
        finalquotepackageservices3 &&
        finalquotepackageservices3.map((service) => {
          const basePrice = service.price || 0;
          const OngoingDicountApply = includeInQuote.discount.value3;
          const basePriceWithDiscount =
            basePrice - basePrice * ((OngoingDicountApply || 0) / 100);

          let vat_applied = "0";
          let price_aftervat = "0";
          if (service.vat === "1") {
            vat_applied = "20";
            price_aftervat =
              basePriceWithDiscount + (basePriceWithDiscount * 20) / 100;
          }

          let price_afterpremimum =
            basePriceWithDiscount +
            basePriceWithDiscount *
            ((includeInQuote.premium.value3 || 0) / 100);

          return {
            ...service,
            mode: "ongoing",
            package_flag: "1",
            premium_applied: includeInQuote.premium.value3 || 0,
            price_afterpremimum: price_afterpremimum || 0,
            discount_rate: OngoingDicountApply,
            price_afterdiscount: basePriceWithDiscount,
            status_discount: "1",
            vat_applied: vat_applied,
            price_aftervat: price_aftervat,
            service_type: "1",
          };
        });

      packageID = includeInQuote.p_id.value3;
      data = {
        // discount: includeInQuote.discount.value3 || 0,
        // premium: includeInQuote.premium.value3 || 0,
        // yearly_cost: includeInQuote.yearlyCost.value3,
        // net_20_vat: includeInQuote.netVat.value3,
        // net_no_vat: includeInQuote.netNoVat.value3,
        // vat: includeInQuote.vat.value3,
        // total_including_vat: includeInQuote.totalIncludingVat.value3

        // Ongoing Services
        discount_ongoing: includeInQuote.discount.value3 || 0,
        premium_ongoing: includeInQuote.premium.value3 || 0,
        threshold_discount_ongoing:
          includeInQuote.threshold_discount_ongoing.value3 || 0,
        status_discount_ongoing: "1",
        payment_term_ongoing: includeInQuote.payment_term_ongoing.value1,
        total_including_ongoing: includeInQuote.totalIncludingVat.value3,
        total_monthly_ongoing:includeInQuote.total_monthly_ongoing.value3,
        payment_type_ongoing: payment_type_ongoing,
        payment_frequency_ongoing: payment_frequency_ongoing,
        net20vat_ongoing: includeInQuote.netVat.value3,
        vat_ongoing: includeInQuote.vat.value3,
        netnovat_ongoing: includeInQuote.netNoVat.value3,
      };
    }

    const req = {
      ...data,
      quotepackageservices: finalquotepackageservices,
      id: Number(QuoteId),
      step: 3,
      packageID: packageID,
      agent_id: agent_id,
    };


    await dispatch(createQuote(req))
      .unwrap()
      .then((res) => {
        if (res.status) {
          nextStep();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };


  return (
    <div>
      <div className="row mb-4">
        <div className="col">
          <h4 className="page-title" >
            <i className="bx bx-arrow-back text-pink pe-1 cursor-pointer" onClick={prevStep} ></i>
            New Quote{" "}
            <span>
              {" "}
             
            </span>
          </h4>
        </div>
      </div>
      <div className="card pt-4">
        <div className="card-body">
          <div className=" needs-validation">
            <div className="row mb-4">
              <div className="col-md-5">
                <div className="row">
                  <label
                    htmlFor="inputEmail3"
                    className="col-sm-4 col-form-label  "
                  >
                    Package type:
                  </label>
                  <div className="col-sm-8 ps-0">
                    <select
                      className="form-select"
                      onChange={(e) => setSelectedPackage(e.target.value)}
                      value={selectedPackage}
                      disabled={true}
                    >
                      {quoteData?.packages?.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="row">
                  <label className="col-sm-4 col-form-label">
                    Compare Package :
                  </label>
                  <div className="col-sm-8 ps-0">
                    <Select
                      isMulti
                      menuPortalTarget={document.body}
                      value={comparePackage}
                      closeMenuOnSelect={false}
                      options={quoteData?.packages
                        ?.filter(
                          (item) =>
                            selectedPackage != item.id && item.status == "1"
                        )
                        .map((item) => ({ value: item.id, label: item.name }))}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      onChange={handlePackageChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-12">
                <MyTableComponent
                  filteredPackages={filteredPackages}
                  AllPackagesServices={AllPackagesServices}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <div className="col-md-8">
                <div className="row justify-content-end">
                  <div className="col-md-3">
                    <label
                      htmlFor="inputEmail3"
                      className="col-form-label   w-100 "
                    >
                      Include in Quote:
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2 row text-center" key={index}>
                        <div className="form-check col-lg-3">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`gridCheck${index + 1}`}
                            checked={
                              includeInQuote.include[`value${index + 1}`] ||
                              false
                            }
                            onChange={(e) => {
                              if (includeInQuote.include[`value${index + 1}`])
                                return;

                              setIncludeInQuote((prev) => {
                                const newInclude = {};
                                Object.keys(prev.include).forEach((key) => {
                                  newInclude[key] = false;
                                });

                                newInclude[`value${index + 1}`] = true;

                                return {
                                  ...prev,
                                  include: newInclude,
                                };
                              });
                            }}
                          />
                        </div>
                      </div>
                    )
                  )}
                </div>
                <div className="row justify-content-end">
                  <div className="col-md-3">
                    <label
                      htmlFor="inputEmail3"
                      className="col-form-label text-end w-100"
                    >
                      Discount (%):
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2" key={index}>
                        <input
                          type="number"
                          className="form-control"
                          disabled
                          value={
                            includeInQuote.discount[`value${index + 1}`] ||
                            "0.00"
                          }
                          onChange={(e) => {
                            setIncludeInQuote((prev) => ({
                              ...prev,
                              discount: {
                                ...prev.discount,
                                [`value${index + 1}`]: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                    )
                  )}
                </div>

                <div className="row justify-content-end mt-2">
                  <div className="col-md-3">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label  text-end w-100 "
                    >
                      Premium(%):
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2" key={index}>
                        <input
                          type="number"
                          className="form-control"
                          disabled
                          min="0" // Minimum value set to 0
                          value={
                            includeInQuote.premium[`value${index + 1}`] ||
                            "0.00"
                          }
                          onChange={(e) => {
                            let value = parseFloat(e.target.value);
                            if (value < 0) value = 0; // Prevent negative values

                            let paymentFrequencyValue;

                            setIncludeInQuote((prev) => ({
                              ...prev,
                              premium: {
                                ...prev.premium,
                                [`value${index + 1}`]: value,
                              },

                              totalIncludingVat: {
                                ...prev.totalIncludingVat,
                                [`value${index + 1}`]: (
                                  (parseFloat(
                                    includeInQuote.netNoVat[`value${index + 1}`]
                                  ) +
                                    // parseFloat(includeInQuote.vat[`value${index + 1}`]) +
                                    parseFloat(
                                      includeInQuote.netVat[`value${index + 1}`]
                                    ) +
                                    (parseFloat(
                                      includeInQuote.netNoVat[
                                      `value${index + 1}`
                                      ]
                                    ) +
                                      //parseFloat(includeInQuote.vat[`value${index + 1}`])
                                      parseFloat(
                                        includeInQuote.netVat[
                                        `value${index + 1}`
                                        ]
                                      )) *
                                    (100 /
                                      (100 -
                                        parseFloat(
                                          includeInQuote.discount[
                                          `value${index + 1}`
                                          ] || 0
                                        ))) *
                                    (value / 100)) /
                                  paymentFrequencyValue +
                                  parseFloat(
                                    includeInQuote.vat[`value${index + 1}`]
                                  )
                                ).toFixed(2),
                              },
                            }));
                          }}
                        />
                      </div>
                    )
                  )}
                </div>

                {/* <div className="row justify-content-end mt-2">
                  <div className="col-md-3">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label  text-end w-100 "
                    >
                      Yearly cost:
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map((_, index) => (
                    <div className="col-md-2" key={index}>
                      <input
                        type="number"
                        disabled
                        className="form-control"
                        value={includeInQuote.yearlyCost[`value${index + 1}`] || '0.00'}
                        onChange={(e) => {
                          setIncludeInQuote((prev) => ({
                            ...prev,
                            yearlyCost: { ...prev.yearlyCost, [`value${index + 1}`]: e.target.value },
                          }));
                        }}
                      />
                    </div>
                  ))}
                </div> */}

                <div className="row justify-content-end mt-2">
                  <div className="col-md-3">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label  text-end w-100 "
                    >
                      Net @ 20% VAT:
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2" key={index}>
                        <input
                          type="number"
                          className="form-control"
                          disabled
                          value={
                            includeInQuote.netVat[`value${index + 1}`] || "0.00"
                          }
                          onChange={(e) => {
                            setIncludeInQuote((prev) => ({
                              ...prev,
                              netVat: {
                                ...prev.netVat,
                                [`value${index + 1}`]: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                    )
                  )}
                </div>

                <div className="row justify-content-end mt-2">
                  <div className="col-md-3">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label  text-end w-100 "
                    >
                      Net @ No VAT:
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2" key={index}>
                        <input
                          type="number"
                          className="form-control"
                          disabled
                          value={
                            includeInQuote.netNoVat[`value${index + 1}`] ||
                            "0.00"
                          }
                          onChange={(e) => {
                            setIncludeInQuote((prev) => ({
                              ...prev,
                              netNoVat: {
                                ...prev.netNoVat,
                                [`value${index + 1}`]: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                    )
                  )}
                </div>

                <div className="row justify-content-end mt-2">
                  <div className="col-md-3">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label  text-end w-100 "
                    >
                      VAT:
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2" key={index}>
                        <input
                          type="number"
                          className="form-control"
                          disabled
                          value={
                            includeInQuote.vat[`value${index + 1}`] || "0.00"
                          }
                          onChange={(e) => {
                            setIncludeInQuote((prev) => ({
                              ...prev,
                              vat: {
                                ...prev.vat,
                                [`value${index + 1}`]: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                    )
                  )}
                </div>

                <div className="row justify-content-end mt-2">
                  <div className="col-md-4">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label   text-end w-100 "
                    >
                      Total Including VAT:
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2" key={index}>
                        <input
                          disabled
                          type="number"
                          className="form-control"
                          value={
                            includeInQuote.totalIncludingVat[
                            `value${index + 1}`
                            ] || "0.00"
                          }
                          onChange={(e) => {
                            setIncludeInQuote((prev) => ({
                              ...prev,
                              totalIncludingVat: {
                                ...prev.totalIncludingVat,
                                [`value${index + 1}`]: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                    )
                  )}
                </div>

               

                {/* <div className="row justify-content-end mt-2">
                  <div className="col-md-4">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label   text-end w-100 "
                    >
                     Payment Terms
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map((_, index) => (
                    <div className="col-md-2" key={index}>
                      <input
                        disabled
                        type="text"
                        className="form-control"
                        value={includeInQuote.payment_term_ongoing[`value${index + 1}`] || '0.00'}
                        onChange={(e) => {
                          setIncludeInQuote((prev) => ({
                            ...prev,
                            payment_term_ongoing: { ...prev.payment_term_ongoing, [`value${index + 1}`]: e.target.value },
                          }));
                        }}
                      />
                    </div>
                  ))}
                </div> */}

                <div className="row justify-content-end mt-2">
                  <div className="col-md-4">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label   text-end w-100 "
                    >
                      Admin Charge:
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2" key={index}>
                        <input
                          disabled
                          type="number"
                          className="form-control"
                          value={
                            includeInQuote.admin_charge_ongoing[
                              `value${index + 1}`
                            ] == null
                              ? 0
                              : includeInQuote.admin_charge_ongoing[
                              `value${index + 1}`
                              ] || "0.00"
                          }
                          onChange={(e) => {
                            setIncludeInQuote((prev) => ({
                              ...prev,
                              admin_charge_ongoing: {
                                ...prev.admin_charge_ongoing,
                                [`value${index + 1}`]: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                    )
                  )}
                </div>

                <div className="row justify-content-end mt-2">
                  <div className="col-md-4">
                    <label
                      htmlFor="inputEmail3"
                      className=" col-form-label   text-end w-100 "
                    >
                      Total{" "}
                      {includeInQuote.payment_frequency_ongoing.value1
                        .charAt(0)
                        .toUpperCase() +
                        includeInQuote.payment_frequency_ongoing.value1.slice(
                          1
                        )}{" "}
                      Cost:
                    </label>
                  </div>
                  {Array.from({ length: comparePackage?.length + 1 }).map(
                    (_, index) => (
                      <div className="col-md-2" key={index}>
                        <input
                          disabled
                          type="number"
                          className="form-control"
                          value={
                            includeInQuote.total_monthly_ongoing[
                            `value${index + 1}`
                            ] || "0.00"
                          }
                          onChange={(e) => {
                            setIncludeInQuote((prev) => ({
                              ...prev,
                              total_monthly_ongoing: {
                                ...prev.total_monthly_ongoing,
                                [`value${index + 1}`]: e.target.value,
                              },
                            }));
                          }}
                        />
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
            <hr />

            <div className="d-flex justify-content-between mt-3">
              {currentStep > 1 && (
                <button className="btn btn-secondary" onClick={prevStep}>
                  Previous
                </button>
              )}
              <button className="btn btn-pink" onClick={handleSubmit}>
                {currentStep < 4 ? "Next" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepThree;
